import { Component } from '@angular/core';

@Component({
    selector: 'app-new-release-info-popup',
    templateUrl: '../../../src/assets/release//release.html',
    styleUrls: ['./new-release-info-popup.component.scss'],
})
export class NewReleaseInfoPopupComponent {}
